<template>
  <div id="newsContent">
    <div id="tab-bar">
      <ul class="tab-bom">
        <li style="padding-right: 15%" @click="routerFuc('/home')" :class="{on:$route.path.includes('/home')}"><img src="https://img.deepbaytech.com/fn/logo.png" style=" border: none; height: 34px;"></li>
        <li @click="routerFuc('/home')" :class="{on:$route.path.includes('/home')}">首页</li>
        <li @click="routerFuc('/solution')" :class="{on:$route.path.includes('/solution')}">解决方案
        </li>
        <li @click="routerFuc('/news')" :class="{on:$route.path.includes('/news')}">新闻中心</li>
        <li @click="routerFuc('/cooperation')" :class="{on:$route.path.includes('/cooperation')}">
          商务合作</li>
        <li @click="routerFuc('/about')" :class="{on:$route.path.includes('/about')}">关于我们</li>
        <li style="margin-left: 15%">
          <span class="on"></span>

          <span></span>
        </li>
      </ul>
    </div>
    <div class="container" style="padding:4px 0;">
      <div class="breadcrumb">
        <a href="/news">新闻中心</a>
        <div><img src="https://img.deepbaytech.com/images/fill@2x.png"></div>
        <a href="" class="news-text">正文</a>
      </div>
      <div class="document-content">
        <div class="document-content-left">
          <div class="document-content-left-title">{{contentListdata.informationTitle}}</div>
          <div class="document-content-left-auth">
            <div>{{contentListdata.informationAuthor}}</div>
            <div>{{contentListdata.publishTime.slice(0,10)}}</div>
          </div>
          <!--后台内容-->
          <div id="cccxxx" v-if="this.text.indexOf('.mp4') == -1" v-html="text"></div>
          <video class="video-play" v-else controls muted :src="text"></video>
          <!--提示-->
          <!-- <div class="document-tip">原创声明，本文系作者{{contentListdata.informationAuthor}}官方团队发表，未经许可，不得转载。</div> -->
          <!--底部文章链接-->
          <div class="document-other-url" v-if="contentListdata.prevArticleTitle">
            <p class="url-list" @click="routerNewsContent(contentListdata.prevArticleId)">
              上一篇：{{contentListdata.prevArticleTitle}}</p>
            <br />
            <p class="url-list" @click="routerNewsContent(contentListdata.nextArticleId)">
              下一篇：{{contentListdata.nextArticleTitle}}</p>
          </div>
        </div>
        <div class="mainNews-list-right" v-if="hotdata">
          <p class="mainNews-hot">热门推荐</p>
          <hr />
          <ul class="mainNews-hot-list">
            <li v-for="(hot,index) in hotdata" :key="index" @click="routerNewsContent(hot.informationId)">{{hot.informationTitle}}</li>
          </ul>
        </div>
      </div>
    </div>
    <!-- 服务咨询 -->
    <Consultation />
    <!-- 尾部 -->
    <Footer />
  </div>
</template>
<script>
//11111
import Consultation from "./../../components/Consultation/Consultation"
import Footer from "./../../components/Footer/Footer"
import { getNewsContent, getNewsHot } from './../../api/index'
export default {
  name: 'NewsContent',
  components: {
    Consultation,
    Footer
  },
  data () {
    return {
      contentList: '',
      contentListdata: '',
      informationId: '',
      orderType: 0,
      text: '',
      hotdata: ''
    }
  },
  mounted () {
    console.log(this.$route.params.id)
    this.informationId = this.$route.params.id
    this.getContentFuc()
    this.getHotFuc()
  },
  methods: {
    routerFuc (path) {
      this.informationId = this.$router.push(path)
    },
    async getContentFuc () {
      this.contentList = await getNewsContent(this.informationId, this.orderType)
      this.contentListdata = this.contentList.data
      console.log(this.contentListdata)
      this.text = this.contentListdata.informationContent
    },
    async getHotFuc () {
      this.hot = await getNewsHot()
      this.hotdata = this.hot.data
      console.log(this.hotdata)
    },
    routerNewsContent (id) {
      this.informationId = id
      this.getContentFuc()
    },
  }
}
</script>
<style scoped>
#tab-bar {
  margin: 0;
  padding: 0;
  width: 100%;
  background-color: rgba(255, 255, 255, 1);
  color: #000000;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 999;
  font-size: 14px;
}
.tab-bom {
  width: 100%;
  height: 64px;
  padding: 0;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.tab-bom > li {
  list-style: none;
  cursor: pointer;
}
.tab-bom > li:hover {
  color: #fd6622;
}
.on {
  color: #fd6622;
}
.container {
  background-color: #f5f5f5;
}
a {
  text-decoration: none;
}
.nav {
  background: #061037;
  position: static;
}
.breadcrumb {
  width: 1180px;
  margin: auto;
  height: 60px;
  display: flex;
  align-items: center;
  margin-top: 20px;
}
.breadcrumb > a {
  font-size: 14px;
  color: #333;
}
.news-text {
  color: #999 !important;
}
.breadcrumb img {
  width: 7px;
  height: 11px;
  margin: 0 10px;
}
.document-content {
  width: 1180px;
  margin: 0 auto;
  display: flex;
}
#cccxxx {
  width: 100%;
  height: auto;
}
#cccxxx >>> img {
  width: 100%;
  height: auto;
}
.video-play {
  width: 710px;
}
/*left*/
.document-content-left {
  width: 820px;
  background: #fff;
  padding: 40px;
}
.document-content-left-title {
  color: #333;
  font-size: 24px;
  font-weight: 900;
}
.document-content-left-auth {
  display: flex;
  align-items: center;
  margin: 16px 0 40px 0;
  color: #999;
  font-size: 14px;
}
.document-content-left-auth > div:first-child {
  color: #fd6622;
}
.document-content-left-auth > div:nth-child(2) {
  margin: 0 22px 0 20px;
}
.document-tip {
  color: #999;
  font-size: 14px;
  margin: 40px 0;
}
.url-list {
  color: #fd6622;
  font-size: 14px;
  border-bottom: 1px solid transparent;
  display: inline-block;
  cursor: pointer;
}
.url-list:not(:last-child) {
  margin-bottom: 8px;
}
.url-list:hover {
  border-bottom: 1px solid #fd6622;
}
hr {
  border: none;
  height: 1px;
  background-color: #e5e5e5;
}
.mainNews-list-right {
  background: #fff;
  border-top: 3px solid #fd6622;
  margin-left: 20px;
  padding: 20px;
}
.mainNews-hot {
  color: #333333;
  font-size: 16px;
  margin-bottom: 20px;
  margin-top: 10px;
}
.mainNews-hot-list {
  margin-left: 16px;
  padding-bottom: 50px;
}
.mainNews-hot-list li {
  margin-top: 20px;
  color: #666666;
  font-size: 14px;
  cursor: pointer;
}
.mainNews-hot-list li:hover {
  color: #fd6622;
}
</style>
